import { render } from "./About.vue?vue&type=template&id=2b5fef9f&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-2b5fef9f"

export default script